/** biome-ignore-all lint/performance/noImgElement: static illustration assets from public/tracking */
import { Button } from "@components/button/button-untitledui";
import { COMMUNICATION_ILLUSTRATIONS } from "../constants";

type CommunicationFeedbackStateProps =
	| {
			variant: "empty";
			hasSearch: boolean;
			onClearFilters: () => void;
	  }
	| {
			variant: "error";
			onRetry: () => void;
	  };

export function CommunicationFeedbackState(
	props: CommunicationFeedbackStateProps
) {
	if (props.variant === "error") {
		return (
			<div
				className="flex flex-col items-center gap-5 px-6 py-12 text-center"
				data-slot="communication-feedback-state"
			>
				<img
					alt=""
					aria-hidden
					className="h-[162px] w-[151px] object-contain"
					height={162}
					src={COMMUNICATION_ILLUSTRATIONS.error}
					width={151}
				/>
				<div className="flex max-w-[560px] flex-col gap-2">
					<h3 className="font-semibold text-primary text-xl leading-[30px]">
						Ops! Não foi possível carregar os dados
					</h3>
					<p className="text-base text-tertiary leading-6">
						Tivemos um problema de conexão com o servidor.
					</p>
				</div>
				<Button color="secondary" onClick={props.onRetry} size="sm">
					Tentar novamente
				</Button>
			</div>
		);
	}

	const title = props.hasSearch
		? "Nenhum veículo encontrado com esta placa"
		: "Nenhum veículo encontrado";

	return (
		<div
			className="flex flex-col items-center gap-5 px-6 py-12 text-center"
			data-slot="communication-feedback-state"
		>
			<img
				alt=""
				aria-hidden
				className="h-[175px] w-[151px] object-contain"
				height={175}
				src={COMMUNICATION_ILLUSTRATIONS.emptySearch}
				width={151}
			/>
			<div className="flex max-w-[352px] flex-col gap-2">
				<h3 className="font-semibold text-primary text-xl leading-[30px]">
					{title}
				</h3>
				<p className="text-base text-tertiary leading-6">
					Não localizamos informações compatíveis com os filtros selecionados.
					Verifique se a placa está correta ou ajuste os filtros aplicados.
				</p>
			</div>
			<Button color="secondary" onClick={props.onClearFilters} size="sm">
				Limpar filtros
			</Button>
		</div>
	);
}
